import type { FunctionComponent } from 'react';
import { useEffect, useRef } from 'react';

import { sandboxParams } from 'app/scripts/data/plugin-iframe-sandbox';
import { PluginView } from 'app/scripts/views/plugin/PluginView';

interface NewPluginPopoverIframeProps {
  title: string;
  url: string;
  height: number;
  args?: {
    [key: string]: string;
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  model: any;
}

export const NewPluginPopoverIframe: FunctionComponent<
  NewPluginPopoverIframeProps
> = ({ url, height, title, model }) => {
  const divRef = useRef<HTMLDivElement>(null);
  const pluginViewRef = useRef<PluginView | null>(null);

  useEffect(() => {
    // Eventually we should be able to move away from relying on PluginView but for now we will use
    // it to initialize frames
    if (divRef.current) {
      pluginViewRef.current = new PluginView();
      pluginViewRef.current.$el = $(divRef.current);

      // @ts-expect-error TS(2555): Expected at least 2 arguments, but got 1.
      pluginViewRef.current.initIFrames(model);
    }
  }, [model]);

  return (
    <div ref={divRef}>
      <iframe
        src={url}
        height={height}
        title={title}
        // eslint-disable-next-line @eslint-react/dom/no-missing-iframe-sandbox -- FIXME
        sandbox={sandboxParams}
        allow="microphone; camera"
        className="plugin-iframe"
      />
    </div>
  );
};
